// src/context/DataContext.js
import React, { createContext, useState, useEffect, useContext, useCallback } from "react";
import { fetchDatos } from "../services/api";
import { AuthContext } from "./AuthContext";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const { token, currentUser: user } = useContext(AuthContext);

  // Estados locales
  const [data, setData] = useState([]);
  const [collegeName, setCollegeName] = useState("Mi Colegio");
  const [loadingData, setLoadingData] = useState(false);
  const [errorData, setErrorData] = useState(null);
  const [colegioSeleccionado, setColegioSeleccionado] = useState("");


  // Función para cargar los datos, memorizada con useCallback
  const loadData = useCallback(async (collegeId) => {
    // Si no hay token, no hacemos nada
    if (!token) {
      setData([]);
      setErrorData(null);
      setLoadingData(false);
      return;
    }

    // Identificar el ID a usar: el pasado por argumento O el del usuario
    const targetId = collegeId || user?.categoryId;

    // Si NO hay ID (ni argumento ni usuario), NO llamar a la API para evitar 400
    if (!targetId) {
      // Opcional: setData([]) si queremos limpiar
      setLoadingData(false);
      return;
    }

    try {
      setLoadingData(true);
      setErrorData(null);
      const result = await fetchDatos(targetId);
      setData(result);
      if (result && result.length > 0 && result[0].category_name) {
        setCollegeName(result[0].category_name);
      } else {
        setCollegeName("Mi Colegio");
      }
    } catch (err) {
      console.error("Error al cargar datos:", err.response || err);
      setErrorData(err);
    } finally {
      setLoadingData(false);
    }
  }, [token, user]); // Agregamos user a dependencias

  // useEffect para cargar data cuando cambia el usuario (y tiene categoryId)
  useEffect(() => {
    // Solo cargamos automáticamente si el usuario tiene un colegio asignado por defecto
    if (user?.categoryId) {
      loadData(user.categoryId);
    }
  }, [loadData, user]);

  return (
    <DataContext.Provider value={{ user, data, loadingData, errorData, loadData, collegeName, colegioSeleccionado, setColegioSeleccionado }}>
      {children}
    </DataContext.Provider>
  );
};
